// src/layouts/AdminLayout.jsx
import React, { useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { Box, AppBar, Toolbar, IconButton, Typography } from "@mui/material";
import { Menu } from "lucide-react";
import Sidebar from "../components/layout/Sidebar";

const AdminLayout = () => {
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    
    // Manage responsive mobile overlay status
    const [mobileOpen, setMobileOpen] = useState(false);

    // Route Guard: Verify authentication status and explicit role match
    if (!token || user.role !== "Admin") {
        console.warn("⛔ Unauthorized Admin routing block triggered. Redirecting to auth portal...");
        return <Navigate to="/login" replace />;
    }

    return (
        <Box
            sx={{
                display: "flex",
                bgcolor: "#f8fafc",
                height: "100vh",
                width: "100vw",
                overflow: "hidden"
            }}
        >
            {/* Top Corporate App Header Bar for Mobile Devices Only */}
            <AppBar 
                position="fixed" 
                elevation={0}
                sx={{ 
                    display: { md: "none" }, 
                    bgcolor: "#ffffff", 
                    color: "#0f172a", 
                    borderBottom: "1px solid #f1f5f9",
                    zIndex: 1100
                }}
            >
                <Toolbar sx={{ gap: 1 }}>
                    <IconButton 
                        edge="start" 
                        onClick={() => setMobileOpen(!mobileOpen)} 
                        sx={{ color: "#475569" }}
                    >
                        <Menu size={22} />
                    </IconButton>
                    <Typography variant="subtitle1" sx={{ fontWeight: 800, color: "#4f46e5", fontSize: "0.95rem" }}>
                        Admin Command Console
                    </Typography>
                </Toolbar>
            </AppBar>

            {/* 1. Sidebar Panel Layer (With Responsive State Wiring) */}
            <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />

            {/* 2. Main Panel Workspace Content Display Area */}
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    height: "100vh",
                    overflowY: "auto",
                    overflowX: "hidden",
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                    pt: { xs: "80px", md: 0 },
                    pb: 0,
                    px: { xs: 2, md: 0 }
                }}
            >
                <Outlet />
            </Box>
        </Box>
    );
};

export default AdminLayout;